/**
 * Set REACT_APP_DEBUG_COMPANION_PACING=true to log client-side pacing (VAD, WS, REST).
 * UserInput PCM over the socket is many small messages per second; CompanionStreamingService
 * aggregates those into ~1s summaries so the console stays readable.
 */
export function debugCompanionPacing(
  message: string,
  data?: Record<string, unknown>,
): void {
  if (process.env.REACT_APP_DEBUG_COMPANION_PACING !== "true") {
    return;
  }
  if (data !== undefined) {
    console.info("[companion-pacing]", message, data);
  } else {
    console.info("[companion-pacing]", message);
  }
}
